import React, { useState } from 'react';
import { FormControl, IconButton, Input, InputLabel } from '@mui/material';
import ImageComponents from '../../../../../Shared/ImageComponents';

function RazorPayDialog({ displayOrderNo, amountToBePaid , handleCloseDialog , onBalanceUpdate, rzpWalletTextChangeToHide = false, rzpWalletPartnerCode = '' }) {
    const [username, setUsername] = useState(rzpWalletPartnerCode || '');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [userError, setUserError] = useState(false);
    const [pswdError, setPswdError] = useState(false);
    const [userpswdError, setUserpswdError] = useState(false);
    const [balance, setBalance] = useState(null);
    const [isWalletDivVisible, setWalletDivVisible] = useState(true);
    const [isRzpWalletDivVisible, setRzpWalletDivVisible] = useState(false);
    const [isButtonDisabled, setButtonDisabled] = useState(false);

    const clearHintErrorsOnFocus = () => {
        setUserError(false);
        setPswdError(false);
        setUserpswdError(false);
    };

    const handleAuthClick = async () => {
        setLoading(true);
        setUserError(false);
        setPswdError(false);
        setUserpswdError(false);
        
         if (!username) {
            setUserError(true);
            setLoading(false);
            return;
        }

        if (!password) {
            setPswdError(true);
            setLoading(false);
            return;
        }

       const data = {
            username: encodeURIComponent(username),
            password: encodeURIComponent(password),
            orderNo: encodeURIComponent(displayOrderNo),
        };

        try {
           
            const response = await fetch('/pay/wallet/authenticate', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

           
            const responseData = await response.json();

            if (responseData.data.iSuccess === '1') {
                const userBalance = responseData.data.balance;
                setBalance(userBalance);
                onBalanceUpdate(userBalance);

               
                if (amountToBePaid > userBalance) {
                    setButtonDisabled(true);
                }

                setWalletDivVisible(false);
                setRzpWalletDivVisible(true);
                setLoading(false);
            } else {
               
                setUserpswdError(true);
                setLoading(false);
            }
        } catch (error) {
            
            setUserpswdError(true);
            setLoading(false);
        }
    };

    return (
    
        <div className='razor-pay-dialog-box'>
            <IconButton className='close-btn' onClick={()=> handleCloseDialog ? handleCloseDialog() : null}>
                <ImageComponents name={'closeBtn'} />
            </IconButton>
            <h3>Wallet Login</h3>
            <div
              className={
                userpswdError || userError || pswdError
                  ? 'razor-pay-dialog-hint razor-pay-dialog-hint--error'
                  : 'razor-pay-dialog-hint'
              }
              id="wallet-login-hint"
            >
              {userpswdError
                ? 'Your username and password do not match. Please try again.'
                : userError
                  ? 'Please enter a Username'
                  : pswdError
                    ? 'Please enter a Pin/Password'
                    : 'Please enter your Username and Pin/Password to login'}
            </div>
            <div className='form-group'>
                <FormControl fullWidth>
                    <InputLabel htmlFor="username">Username</InputLabel>
                    <Input
                        id="username"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        onFocus={clearHintErrorsOnFocus}
                        aria-describedby="wallet-login-hint"
                        disabled={!!rzpWalletPartnerCode}
                        readOnly={!!rzpWalletPartnerCode}
                    />
                </FormControl>
            </div>
            <div className='form-group'>
                <FormControl fullWidth>
                    <InputLabel htmlFor="password">Pin/Password</InputLabel>
                    <Input
                        id="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        onFocus={clearHintErrorsOnFocus}
                        aria-describedby="wallet-login-hint"
                    />
                </FormControl>

                {!rzpWalletTextChangeToHide && (
                <div className='login-notify'>
                <p>*Users who have moved to PIN should use PIN</p>
                <p>*Setup PIN now on Wallet Dashboard</p>
            </div>)}
            </div>
            <button
                className='submit-btn'
                onClick={handleAuthClick}
                disabled={isButtonDisabled || loading}
            >
                {loading ? 'Loading...' : 'Submit'}
            </button>
        </div>
      

        
    );
}

export default RazorPayDialog;

